import React, { useState } from "react";
import axios from "axios";
import { MdClose } from "react-icons/md";

const ExchangeStatusModal = ({ isOpen, onClose, order, refreshOrders }) => {
  const [selectedStatus, setSelectedStatus] = useState(
    order.exchangeRequest?.status || "Requested"
  );
  const [loading, setLoading] = useState(false);

  const statuses = ["Approved", "Rejected", "Completed"];

  const handleUpdateExchange = async () => {
    setLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/orders/update-exchange-status/${order._id}`,
        { status: selectedStatus }
      );
      await refreshOrders();
      onClose();
    } catch (err) {
      console.error("Error updating exchange:", err);
      alert("Failed to update exchange status");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white p-6 rounded-lg w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black"
        >
          <MdClose size={20} />
        </button>
        <h2 className="text-xl font-semibold mb-4">
          Update Exchange Status
        </h2>

        <div className="space-y-3 mb-5">
          {statuses.map((s) => (
            <label
              key={s}
              className="flex items-center gap-2 border rounded-lg px-3 py-2 cursor-pointer"
            >
              <input
                type="radio"
                name="exchangeStatus"
                checked={selectedStatus === s}
                onChange={() => setSelectedStatus(s)}
              />
              <span>{s}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleUpdateExchange}
            disabled={loading}
            className="px-5 py-2 rounded bg-[#b07d17] text-white hover:bg-[#8c6312]"
          >
            {loading ? "Updating..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExchangeStatusModal;
